const KEY = 'hd_accounts';

export function getAccounts() {
  return JSON.parse(localStorage.getItem(KEY) || '[]');
}

export function saveAccount(account) {
  const accounts = getAccounts();
  const idx = accounts.findIndex(
    a => a.chain === account.chain && a.hdIndex === account.hdIndex
  );
  if (idx >= 0) {
    accounts[idx] = { ...accounts[idx], ...account };
  } else {
    accounts.push({
      ...account,
      id: Date.now().toString(),
      addedAt: Date.now(),
      label: account.label || `${account.chain} #${account.hdIndex}`,
    });
  }
  localStorage.setItem(KEY, JSON.stringify(accounts));
  return accounts;
}

export function deleteAccount(id) {
  const accounts = getAccounts().filter(a => a.id !== id);
  localStorage.setItem(KEY, JSON.stringify(accounts));
  return accounts;
}

export function getActiveAccount(chain) {
  const id = localStorage.getItem(`hd_active_${chain}`);
  if (!id) return null;
  return getAccounts().find(a => a.id === id) || null;
}

export function setActiveAccount(chain, id) {
  localStorage.setItem(`hd_active_${chain}`, id);
}

export function clearActiveAccount(chain) {
  localStorage.removeItem(`hd_active_${chain}`);
}
